import * as bi from 'react-bootstrap-icons';
import { Box, Button, Flex, Header, Message } from 'components';
import { Icon, IconMax, PageSidebar } from 'shared/components';
import { RoutingUrls } from 'common/const';
import { handleAuthError } from 'common/handlers';
import { ApiPassengers } from 'common/api';
import { useEffect } from 'react';
import './style.scss';
import { Link } from 'react-router';
import { PublicDocumentsService } from 'common/services';

function PageMain() {
  useEffect(() => {
    loadPassengers();
  });

  // TODO: Временно, чтобы при входе выкидавало на авторизацию.
  const loadPassengers = async () =>
    handleAuthError(async () => {
      await ApiPassengers.getInstance().getAll();
    });

  const handleFindTicketsClick = () => {
    window.location.href = RoutingUrls.Trips;
  };

  return (
    <PageSidebar
      title='Главная страница'
      frameTitle='Главная страница'
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Box padding={20}>
          <Flex
            direction='column'
            gap={20}
          >
            <Header>Добро пожаловать!</Header>

            <div>
              У нас вы можете приобрести билеты на междугородные и туристические рейсы как внутри России, так и за её
              пределы.
            </div>

            <Message
              type='info'
              title='Внимание'
            >
              Наш сайт находится на стадии активной разработки, поэтому вы можете столкнуться с ошибками и
              недоработками, о них вы можете сообщать в нашу <a href='#'>техническую поддержку</a>.
            </Message>

            <Button
              color='red'
              onClick={handleFindTicketsClick}
            >
              Поиск билетов
            </Button>
          </Flex>
        </Box>

        <Box padding={20}>
          <Flex
            direction='column'
            gap={20}
          >
            <Header>Информация о нас</Header>

            <Flex
              direction='column'
              gap={0}
            >
              <p>
                Уже более 25 лет АО «Читаавтотранс» обеспечивает комфортные и безопасные пассажирские перевозки в
                Забайкальском крае. Стремясь сделать обслуживание ещё удобнее для наших клиентов и партнёров, мы
                запустили современный онлайн-сервис <Link to={RoutingUrls.Main}>Zabus.RU</Link> – простой и быстрый
                способ покупки билетов!
              </p>

              <Flex
                direction='column'
                gap={10}
              >
                <Flex direction='column'>
                  <Flex gap={5}>
                    <Icon color='red'>
                      <bi.Briefcase />
                    </Icon>
                    <b>Наш ОГРН:</b>
                    <span>1027501147629</span>
                  </Flex>
                  <Flex gap={5}>
                    <Icon color='red'>
                      <bi.Clipboard />
                    </Icon>
                    <b>Наш ИНН:</b>
                    <span>7536033811</span>
                  </Flex>
                </Flex>

                <Flex direction='column'>
                  <Flex gap={5}>
                    <Icon color='red'>
                      <bi.Telegram />
                    </Icon>
                    <b>Telegram:</b>
                    <Link
                      to='https://t.me/chitaavtotrans75'
                      target='_blank'
                    >
                      @ChitaAvtoTrans75
                    </Link>
                  </Flex>
                  <Flex gap={5}>
                    <Icon color='red'>
                      <IconMax />
                    </Icon>
                    <b>МАКС:</b>
                    <span>+7 (914) 350‒26‒26</span>
                  </Flex>
                </Flex>

                <Flex direction='column'>
                  <Flex gap={5}>
                    <Icon color='red'>
                      <bi.Telephone />
                    </Icon>
                    <a href='tel:73022502626'>+7 (3022) 50‒26‒26</a>
                  </Flex>
                  <Flex gap={5}>
                    <Icon color='red'>
                      <bi.Telephone />
                    </Icon>
                    <a href='tel:73022352686'>+7 (3022) 35‒26‒86</a>
                  </Flex>
                  <Flex gap={5}>
                    <Icon color='red'>
                      <bi.Telephone />
                    </Icon>
                    <a href='tel:79143502626'>+7 (914) 350‒26‒26</a>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>

            <Flex
              direction='column'
              gap={0}
            >
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={PublicDocumentsService.getInstance().consentHref()}
              >
                <Flex
                  direction='row'
                  gap={5}
                >
                  <Icon color='red'>
                    <bi.JournalCheck />
                  </Icon>

                  <span>Согласие на обработку персональных данных</span>
                </Flex>
              </a>

              <a
                href={PublicDocumentsService.getInstance().privacyPolicyHref()}
                target='_blank'
                rel='noopener noreferrer'
              >
                <Flex
                  direction='row'
                  gap={5}
                >
                  <Icon color='red'>
                    <bi.JournalCheck />
                  </Icon>

                  <span>Политика обработки персональных данных</span>
                </Flex>
              </a>
            </Flex>
          </Flex>
        </Box>
      </Flex>
    </PageSidebar>
  );
}
export default PageMain;
